/** @format */
import { ButtonVariant } from '@mpb-com/feather/components/atoms/button';

import { OriginalContentHeaderVariant } from './index';

export function getBackgroundStyle(variant: OriginalContentHeaderVariant) {
    switch (variant) {
        case OriginalContentHeaderVariant.SUSTAINABILITY:
            return 'var(--colors-sustainability)';
        case OriginalContentHeaderVariant.PROMOTIONS:
        default:
            return 'var(--colors-surface-inverse)';
    }
}

export function getButtonVariant(variant: OriginalContentHeaderVariant) {
    switch (variant) {
        case OriginalContentHeaderVariant.PROMOTIONS:
            return ButtonVariant.TERTIARY;
        case OriginalContentHeaderVariant.SUSTAINABILITY:
            return ButtonVariant.TERTIARY;
        default:
            return ButtonVariant.PRIMARY_INVERTED;
    }
}
